<template>
  <div>
    <div class="grid-template" v-show ="showtable === 'myReport'">
      <div class="table-responsive">
        <table class="table is-bordered is-striped is-narrow is-fullwidth">
          <thead>
            <tr>
              <th v-for="key in columns"
                @click="sortBy(key),showSortIcon()"
                :class="{ active: sortKey == key }">
                <div>
                {{ key | capitalize }}
                <!-- <span v-show="(key === 'Team') && clicked"><i class="fa fa-sort" aria-hidden="true"></i></span>
                <span v-show="(key === 'Your Score') && !clicked" class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                </span> -->
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in filteredData">
              <td v-bind:class="GetRiskColor(entry[key])" v-for="key in columns">
                {{entry[key]}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Array,
      columns: Array,
      average: Array,
      averageColumn: Array,
      showtable: String
    },
    data: function () {
      var sortOrders = {}
      this.columns.forEach(function (key) {
        sortOrders[key] = 1
      })
      return {
        clicked: true,
        colorTrue: false,
        sortKey: '',
        sortOrders: sortOrders
      }
    },
    computed: {
      filteredData: function () {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.data
        // console.log('1')
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      }
    },
    filters: {
      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
    },
    methods: {
      sortBy: function (key) {
        if (key === 'Your Score' || key === 'Baseline Score' || key === 'Baseline+ Score' || key === 'Risk Priority' || key === 'Priority') {
          this.sortKey = key
          this.sortOrders[key] = this.sortOrders[key] * -1
        }
      },
      showSortIcon () {
        this.clicked = false
      },
      GetRiskColor: function (riskValue) {
        if (riskValue > 0 && riskValue <= 3) {
          return 'colorGreen'
        } else if (riskValue > 3 && riskValue <= 6) {
          return 'colorYellow'
        } else if (riskValue > 6 && riskValue <= 9) {
          return 'colorRed'
        } else {
          return 'colorDefault'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.colorDefault {
  background-color: #f9f9f9;
}
.colorDefault1 {
  background-color: #e6e6e6 !important;
}
.colorDefault2 {
  background-color: #f5f5f5 !important;
}

th {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: .66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}

.grid-template {
  @media print {
    table {
      margin-top: 5px !important;
      margin-bottom: 5px !important;
      thead {
        th {
          font-weight: 800;
          vertical-align : middle !important;
          font-size: 12px;
        }
      }
      td {
        vertical-align : middle !important;
      }
      tbody {
        td {
          font-size: 10px;
        }
      }
      tfoot {
        td {
          font-size: 10px;
        }
      }
    }
  }
  table {
    thead {
      background: lightgrey !important;
      tr {
        &:hover {
          background: lightgrey !important;
        }
        &:first-child {
          th:first-child {
            text-align: left !important;
          }
        }
      }
      th {
        font-weight: 800;
        vertical-align : middle !important;
        text-align: center;

        &:first-child {
          border-radius: 10px 0 0 0;
          width: 50%;
        }
        &:last-child {
          width: 10%;
          border-radius: 0 10px 0 0;
          color: #000;
          padding: 0px;
          background: #fff;

          div {
            border: 3px solid #d3d3d3;
            padding: 0.25em 0.5em;
            border-radius: 0 10px 0 0;
          }
        }
      }
    }

    tbody {
      font-size: 14px !important;
      tr {
        background: whitesmoke !important;
        &:hover {
          background: whitesmoke !important;
        }
        td:nth-child(1) {
          text-align: left !important;
        }
      }
      td {
        vertical-align: middle !important;
        text-align: center;
      }
    }

    tfoot {
      background: #e6e6e6 !important;
      font-size: 14px;
      font-weight: bold;
      tr {
        &:hover {
          background: #e6e6e6 !important;
        }
        &:first-child {
          td:first-child {
            text-align: left !important;
          }
        }
        &:last-child td:first-child {
          border-radius: 0 0 0 10px;
        }
        &:last-child td:last-child {
          border-radius: 0 0 10px 0;
        }
        td {
          padding: .5em;
          text-align: center;
          div {
            border-radius: 5px;
          }

          &:nth-last-child(1) {
            div {
              background: #e6e6e6 !important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// tableComponent.vue?df60e132